import { NgModule } from '@angular/core';
// Shared modules

// Module componnets.

// Module directives.

// Module service.
import { UserService } from './user.service';
import { SteamService } from './steam.service';
import { StoreService } from './store.service';
import { PurchaseService } from './purchase.service';
// import SocketService from './socket.service';

@NgModule({
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        UserService,
        SteamService,
        StoreService,
        PurchaseService
    ],
    entryComponents: [
    ]
})
export class SharedServicesModule {
}
